import { ReducerState } from "../../../state/reducers/types"
import { addOrUpdate, remove } from "../../../state/reducers/utils"
import { ActionType, LogisticsAction } from './actionTypes'
import { Driver, Roadmap, Vehicle, DeliveryRoadmap } from "./types"

export type LogisticsState = {
    drivers: Driver[]
    vehicles: Vehicle[]
    roadmaps: Roadmap[]
    deliveryRoadmaps: DeliveryRoadmap[]
}

const initialState: LogisticsState = {
    drivers: [],
    vehicles: [],
    roadmaps: [],
    deliveryRoadmaps: []
}

const reducer = (state = initialState, action: LogisticsAction) => {
    switch(action.type) {
        case ActionType.UPDATE_DRIVERS:
            return { 
                ...state,
                drivers: addOrUpdate(state, action, 'drivers' as keyof ReducerState)
            }
        case ActionType.REMOVE_DRIVERS:
            return { 
                ...state,
                drivers: remove(state, action, 'drivers' as keyof ReducerState)
            }
        case ActionType.UPDATE_VEHICLES:
            return {
                ...state,
                vehicles: addOrUpdate(state, action, 'vehicles' as keyof ReducerState)
            }
        case ActionType.REMOVE_VEHICLES:
            return {
                ...state,
                vehicles: remove(state, action, 'vehicles' as keyof ReducerState)
            }
        case ActionType.UPDATE_ROADMAPS:
            return {
                ...state,
                roadmaps: addOrUpdate(state, action, 'roadmaps' as keyof ReducerState)
            }
        case ActionType.REMOVE_ROADMAPS:
            return {
                ...state,
                roadmaps: remove(state, action, 'roadmaps' as keyof ReducerState)
            }
        case ActionType.UPDATE_DELIVERY_ROADMAPS:
            return {
                ...state,
                deliveryRoadmaps: addOrUpdate(state, action, 'deliveryRoadmaps' as keyof ReducerState)
            }
        case ActionType.REMOVE_DELIVERY_ROADMAPS:
            return {
                ...state,
                deliveryRoadmaps: remove(state, action, 'deliveryRoadmaps' as keyof ReducerState)
            }
        default:
            return state
    }
}

export default reducer
